import {
  canSendHouseBroadcastToHouse,
  validateHouseBroadcastCopy,
} from '../../core/rules/houseBroadcast';
import { getManageableHouseIds } from '../../core/rules/houseAccess';
import type { MessageParticipant } from '../../core/rules/messagingAccess';
import type { IMessagingAdapter } from '../../adapters/messaging/IMessagingAdapter';

export async function sendHouseBroadcast(
  adapter: IMessagingAdapter,
  sender: MessageParticipant,
  houseId: string,
  payload: { title: string; body: string },
) {
  const copyError = validateHouseBroadcastCopy(payload.title, payload.body);
  if (copyError) throw new Error(copyError);
  if (!canSendHouseBroadcastToHouse(
    sender.role,
    houseId,
    getManageableHouseIds(sender),
  )) {
    throw new Error('Cannot broadcast to this house.');
  }
  return adapter.sendHouseBroadcast({
    houseId,
    title: payload.title.trim(),
    body: payload.body.trim(),
    fromUid: String(sender.id ?? ''),
    fromName: sender.name ?? '',
    fromRole: sender.role ?? '',
  });
}
